// extracted by mini-css-extract-plugin
module.exports = {"anchored-heading":"api-explorer-field-layout_anchored-heading__7dlbE","cancel-icon":"api-explorer-field-layout_cancel-icon__MOUKf"};